
import { UserSubscriptionTransactionViewModel } from "@/presentation/viewmodels/UserSubscriptionHistoryViewModel";
import { PropType } from "vue";
export default {
  name: "UserSubscriptionTransactionItem",
  props: {
    item: {
      type: Object as PropType<UserSubscriptionTransactionViewModel>,
      required: true,
    },
  },
};
